/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_How_EyebrowInputs */

const es_l7_how_eyebrow = /** @type {(inputs: L7_How_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú registras tu barco`)
};

const gl_l7_how_eyebrow = /** @type {(inputs: L7_How_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti rexistras o teu barco`)
};

const en_l7_how_eyebrow = /** @type {(inputs: L7_How_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You list your boat`)
};

/**
* | output |
* | --- |
* | "You list your boat" |
*
* @param {L7_How_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_how_eyebrow = /** @type {((inputs?: L7_How_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_How_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_how_eyebrow(inputs)
	if (locale === "en") return en_l7_how_eyebrow(inputs)
	return es_l7_how_eyebrow(inputs)
});